"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var BetaBadge = function BetaBadge() {
  return (0, _preact.h)("div", {
    className: "beta-badge"
  }, "BETA");
};

var _default = BetaBadge;
exports.default = _default;